export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

export type MetaStandardEvent = 'PageView' | 'CompleteRegistration' | 'Purchase';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/** Fire a Meta Pixel standard event. No-op (never throws) when fbq isn't loaded. */
export function trackMetaEvent(name: MetaStandardEvent, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', name, params);
}

const PURCHASE_KINDS = new Set(['tier_upgrade', 'renewal']);

/**
 * Read Purchase details off a Xendit return URL. Non-null ONLY for a successful
 * subscription payment (tier_upgrade / renewal) with a positive numeric value.
 */
export function parsePurchaseParams(
  params: URLSearchParams,
): { value: number; kind: string } | null {
  if (params.get('payment') !== 'success') return null;
  const kind = params.get('kind');
  if (!kind || !PURCHASE_KINDS.has(kind)) return null;
  const value = Number(params.get('value'));
  if (!Number.isFinite(value) || value <= 0) return null;
  return { value, kind };
}
